import { motion } from "framer-motion";
import { useLang } from "@/contexts/LanguageContext";
import { useT } from "@/lib/i18n";
import { HOME } from "@/constants/testIds";
import { Link } from "react-router-dom";

const LOGO_ROUND =
    "https://customer-assets-jt897jd0.emergentagent.net/job_18a53554-3c4c-4394-97e9-2d39c51c5281/artifacts/4eg9cvl3_232787.jpg";

const Header = () => {
    const { lang, setLang } = useLang();
    const t = useT(lang);

    return (
        <motion.header
            initial={{ y: -20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8, delay: 2.4, ease: [0.22, 1, 0.36, 1] }}
            className="fixed top-0 inset-x-0 z-40"
        >
            <div className="mx-auto max-w-[1600px] px-6 md:px-10 py-4">
                <div
                    className="flex items-center justify-between rounded-full px-4 md:px-6 py-3 backdrop-blur-xl"
                    style={{
                        background: "rgba(250, 248, 245, 0.72)",
                        border: "1px solid rgba(232, 58, 116, 0.18)",
                    }}
                >
                    <Link
                        to="/"
                        data-testid={HOME.navLogo}
                        className="flex items-center gap-3 group"
                    >
                        <span className="relative block w-10 h-10 rounded-full overflow-hidden anim-spin" style={{ animationDuration: "60s" }}>
                            <img src={LOGO_ROUND} alt="Piñatas con Karina" className="w-full h-full object-cover" />
                        </span>
                        <span className="font-serif text-[15px] md:text-[17px] leading-none tracking-tight" style={{ color: "var(--ink-1)" }}>
                            Piñatas <em className="font-hand text-[22px] md:text-[24px]" style={{ color: "var(--pink)" }}>con Karina</em>
                        </span>
                    </Link>

                    <nav className="hidden md:flex items-center gap-8 font-body text-[13px] uppercase tracking-[0.14em]" style={{ color: "var(--ink-2)" }}>
                        <a href="#catalogue" className="link-underline">{t("nav.services")}</a>
                        <a href="#gallery" className="link-underline">{t("nav.gallery")}</a>
                        <a href="#availability" className="link-underline">{t("nav.availability")}</a>
                        <a href="#contact" data-testid={HOME.navContact} className="link-underline">{t("nav.contact")}</a>
                    </nav>

                    <div className="flex items-center gap-2">
                        <div className="hidden sm:flex items-center rounded-full p-1 border" style={{ borderColor: "rgba(46, 16, 37, 0.18)" }}>
                            <button
                                data-testid={HOME.langToggleEn}
                                onClick={() => setLang("en")}
                                className={`px-3 py-1 rounded-full text-xs font-semibold tracking-wider transition-colors ${
                                    lang === "en" ? "text-white" : ""
                                }`}
                                style={{
                                    background: lang === "en" ? "var(--ink-1)" : "transparent",
                                    color: lang === "en" ? "#fff" : "var(--ink-1)",
                                }}
                            >
                                EN
                            </button>
                            <button
                                data-testid={HOME.langToggleEs}
                                onClick={() => setLang("es")}
                                className="px-3 py-1 rounded-full text-xs font-semibold tracking-wider transition-colors"
                                style={{
                                    background: lang === "es" ? "var(--ink-1)" : "transparent",
                                    color: lang === "es" ? "#fff" : "var(--ink-1)",
                                }}
                            >
                                ES
                            </button>
                        </div>
                        <a
                            href="tel:+18542524440"
                            data-testid={HOME.heroCallBtn}
                            className="btn-pink px-4 md:px-5 py-2 rounded-full text-xs md:text-sm font-semibold tracking-wide"
                        >
                            {t("nav.call")} · (854) 252-4440
                        </a>
                    </div>
                </div>
            </div>
        </motion.header>
    );
};

export default Header;
